import { get } from 'lodash'

const inputText = (params) => {
  const fieldProperties =
    typeof params.fieldProperties == 'string' ? JSON.parse(params.fieldProperties) : params.fieldProperties
  const mask = get(fieldProperties, 'mask')
  const min = get(fieldProperties, 'minValue')
  const max = get(fieldProperties, 'maxValue')
  const required = get(params, 'requiredField', false)

  return Object.freeze({
    type: 'text',
    component: 'inputText',
    mask,
    max,
    min,
    required,
    ...params
  })
}

const inputNumber = (params) => {
  const fieldProperties =
    typeof params.fieldProperties == 'string' ? JSON.parse(params.fieldProperties) : params.fieldProperties
  const mask = get(fieldProperties, 'mask')
  const min = get(fieldProperties, 'minValue')
  const max = get(fieldProperties, 'maxValue')
  const required = get(params, 'requiredField', false)

  return Object.freeze({
    type: 'number',
    component: 'inputNumber',
    max,
    min,
    mask,
    required,
    ...params
  })
}

const inputArea = (params) => {
  const fieldProperties =
    typeof params.fieldProperties == 'string' ? JSON.parse(params.fieldProperties) : params.fieldProperties
  const minlenght = get(fieldProperties, 'minValue')
  const maxlenght = get(fieldProperties, 'maxValue')
  const required = get(params, 'requiredField', false)

  return Object.freeze({
    type: 'textarea',
    component: 'inputArea',
    maxlenght,
    minlenght,
    required,
    ...params
  })
}

const inputDate = (params) => {
  const fieldProperties =
    typeof params.fieldProperties == 'string' ? JSON.parse(params.fieldProperties) : params.fieldProperties
  const required = get(params, 'requiredField', false)
  const dateFormat = get(fieldProperties, 'format')

  return Object.freeze({
    type: 'date',
    component: 'date',
    required,
    dateFormat,
    ...params
  })
}

const switchButton = (params) => {
  const required = get(params, 'requiredField', false)

  return Object.freeze({
    type: 'radio',
    component: 'switchButton',
    required,
    ...params
  })
}

const upload = (params) => {
  const fieldProperties =
    typeof params.fieldProperties == 'string' ? JSON.parse(params.fieldProperties) : params.fieldProperties
  const required = get(params, 'requiredField', false)
  const extensions = get(fieldProperties, 'extensions')

  return Object.freeze({
    component: 'upload',
    required,
    extensions,
    ...params
  })
}

const select = (params, { multiple, component = 'select' }) => {
  const fieldProperties =
    typeof params.fieldProperties == 'string' ? JSON.parse(params.fieldProperties) : params.fieldProperties
  const options = get(fieldProperties, 'options', [])
  const required = get(params, 'requiredField', false)

  return Object.freeze({
    type: 'select',
    component,
    values: options,
    required,
    multiple,
    ...params
  })
}

const inputLocation = (params) => {
  const fieldProperties =
    typeof params.fieldProperties == 'string' ? JSON.parse(params.fieldProperties) : params.fieldProperties
  const mask = get(fieldProperties, 'mask')
  const min = get(fieldProperties, 'minValue')
  const max = get(fieldProperties, 'maxValue')
  const required = get(params, 'requiredField', false)

  return Object.freeze({
    type: 'location',
    component: 'inputLocation',
    mask,
    max,
    min,
    required,
    ...params
  })
}

const mapper = (type, params) => {
  const component = {
    inputText: inputText(params),
    inputNumber: inputNumber(params),
    inputArea: inputArea(params),
    select: select(params, { multiple: false }),
    switchButton: switchButton(params),
    date: inputDate(params),
    upload: upload(params),
    selectTable: select(params, { multiple: false }),
    selectMultiple: select(params, { multiple: true, component: 'selectMultiple' }),
    selectOrder: select(params, { multiple: false, component: 'selectOrder' }),
    message: inputText(params),
    location: inputLocation(params)
  }

  return component[type]
}

const fieldMapper = (fieldType, params) =>
  mapper(fieldType, params) || { component: 'text', type: 'text', placeholder: '' }

export default fieldMapper
